import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = true  // Enable debug mode
window.Stimulus   = application

// Add debug statement
console.log('Stimulus initialized:', !!window.Stimulus)

export { application }
